export const JOB_POSITION_OTHER_UI = "Other (Specify)";
export const JOB_POSITION_OTHER = "Other";
export const MAX_DD_ITEM_VALUE = 37;
export const JOB_POSITION_ID = "job-position-dd";
